import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class StoresItaly extends Page{
    constructor(){
        super({
            id : 'stores_italy',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}